const EventsBus = {
    install (Vue, options) {
        Vue.prototype.$events = new Vue();

        Object.defineProperties(Vue.prototype.$events, {
            on: {
                get() {
                    return this.$on;
                },
            },

            once: {
                get() {
                    return this.$once;
                },
            },

            off: {
                get() {
                    return this.$off;
                },
            },

            emit: {
                get() {
                    return this.$emit;
                },
            },
        });
    }
}

export default EventsBus;
